'use strict';

angular.module('TurneroApp').component('coRecepcionInicio', {
    bindings: {
        centroAtencionSeleccionado: '<'
    },
    controller: [
        'centrosAtencionService',
        '$rootScope',
        'utilsService',
        function (centrosAtencionService, $rootScope, utilsService) {

            var ctrl = this;

            ctrl.Recepcion = {};

            ctrl.$onChanges = function () {
                ctrl.centroAtencionSeleccionado && ctrl.getRecepcion();
            };

            ctrl.getRecepcion = function () {
                centrosAtencionService.Get_Recepcion_Modalidad({ 'id_centro_atencion': ctrl.centroAtencionSeleccionado.id }).$promise.then(function (resultado) {
                    ctrl.Recepcion.Opciones = resultado.Data;
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            }

            ctrl.sacarTurno = function () {
                $rootScope.$broadcast('sacarTurno', true);
            }

            ctrl.tengoTurno = function () {
                $rootScope.$broadcast('anunciarTurno', true);
            }
        }
    ],
    template: require('./recepcionInicio.html')
});



// WEBPACK FOOTER //
// ./app/components/recepcion/recepcionInicioComponent.js